__turbopack_context__.v({
  "skipNavigation": "HPkbSW_skipNavigation",
});
